import React from 'react';
import styled from 'styled-components';

import useIsFeatureEnabled from 'src/presentation/hooks/useIsFeatureEnabled';
import { User, UserStatuses } from 'src/models/Users/User';

const UserStatus = ({ user }: { user: User }): JSX.Element | null => {
  const isFeatureEnabled = useIsFeatureEnabled();
  const ssoEnabled = isFeatureEnabled('sso');

  if (user.status === UserStatuses.DISABLED) {
    return <span data-aid="deactivated-status">{user.status}</span>;
  }

  return !ssoEnabled ? <UserInviteStatus status={user.status} /> : null;
};

const UserInviteStatus = ({ status }): JSX.Element | null => {
  if (status === UserStatuses.DISABLED || status === UserStatuses.ACTIVE) {
    return null;
  }

  const isExpired = status === UserStatuses.INVITE_EXPIRED;
  const invitationText = isExpired ? UserStatuses.INVITE_EXPIRED : UserStatuses.INACTIVE;

  return (
    <UserInviteStatusText data-aid="invite-status" isExpired={isExpired}>
      {invitationText}
    </UserInviteStatusText>
  );
};

const UserInviteStatusText = styled.div`
  color: ${p => (p.isExpired ? p.theme.colors.red300 : p.theme.colors.green400)};
`;

export default UserStatus;
